import { useCallback, useEffect, useLayoutEffect, useRef } from 'react';

const useIsomorphicLayoutEffect = typeof window === 'undefined' ? useEffect : useLayoutEffect;

export const useStableEventCallback = <Args extends unknown[], ReturnValue>(
	callback: (...args: Args) => ReturnValue,
): ((...args: Args) => ReturnValue) => {
	const callbackRef = useRef(callback);

	useIsomorphicLayoutEffect(() => {
		callbackRef.current = callback;
	}, [callback]);

	return useCallback((...args: Args) => callbackRef.current(...args), []);
};
